const PaperProcessInfoDialog = ({ revertToElectronicHandler, confirmPaperProcessHandler }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* Dialog box */}
            <div className="bg-white rounded-lg shadow-lg max-w-xl w-full p-6 mx-4 break-words space-y-4">

                <p>
                    Thank you for your choice. An email with instructions to complete your background screening using paper forms has been
                    sent to your email address. Please refer to that email for the complete paper form process.
                </p>

                <p>
                    For any immediate questions, or if you need further assistance with the non-electronic process, you may contact:
                </p>

                <p className="text-sm sm:text-base font-medium mb-4">
                    VerifiedID<br /> Phone: <a href="tel:+18887182597" className="text-blue-600 underline">(888) 718-2597</a><br />
                    Email: <a href="mailto:support@verifiedid.co" className="text-blue-600 underline">support@verifiedid.co</a>
                </p>

                <p>
                    If you wish to continue electronically, you may click 'Revert to Electronic' below. Otherwise, you can close
                    this window and proceed with the paper process as detailed in the email.
                </p>

                <div className="flex justify-end gap-2">
                    <button
                        onClick={revertToElectronicHandler}
                        className="px-4 py-2 bg-green-600 text-white text-sm rounded hover:bg-green-700"
                    >
                        Revert to Electronic
                    </button>
                    <button
                        onClick={confirmPaperProcessHandler}
                        className="px-4 py-2 bg-gray-600 text-white text-sm rounded hover:bg-gray-700"
                    >
                        Confirm Paper Process
                    </button>
                </div>

            </div>

        </div>
    )
}

export default PaperProcessInfoDialog
